<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->


<div  *ngIf="showLoader">
      <app-project-list-skeleton></app-project-list-skeleton>

</div>

<div *ngIf="!showLoader" class="ai-header">
  <div class="hero-content">
      <div class="logo">
        <img src="../../../assets/ai-sourcing/webbtreeai_sourcing_gif.gif" alt="" class="img-fluid">
      </div>
      <h1 class="text-center">Webbtree Autopilot<sup class="landing f-12"><span>AI</span></sup> </h1>
      <h2>Talent Discovery. Reinvented</h2>
      <div *ngIf="!showCreateProjectBtn && !showGotoProjectListBtn">
        <span>Upload a JD</span>
        <i class="fa-solid fa-circle"></i>
        <span>Set your criteria </span>
        <i class="fa-solid fa-circle"></i>
        <span>Let Autopilot<sup><span>AI</span></sup> do the rest</span>
      </div>
      <p *ngIf="!showCreateProjectBtn && !showGotoProjectListBtn">Finding talent that truly fits, not just matches keywords.</p>
      <button data-testid="auto-app-ai-sourcing-landingpage-button-1" class="btn-joinwaitlist-yellow" *ngIf="showWaitlistBtn" (click)="joinWaitlist()"> Join Waitlist</button>
      <p *ngIf="showRequestedBtn">You’re in the queue! Our team will connect with you soon to proceed further</p>
       <button data-testid="auto-app-ai-sourcing-landingpage-button-2" class="btn-joinwaitlist-yellow mx-auto d-block mb-8" *ngIf="showCreateProjectBtn" (click)="createProject()" > + Create Your First Project</button>
  </div>
</div>
<div *ngIf="!showLoader" class="ai-page-body">
  <div class="col-md-9 mx-auto">
      <p class="f-18 text-center mb-3" *ngIf="!showCreateProjectBtn">Why Webbtree Autopilot<sup><span>AI</span></sup> is different?</p>
      <div class="d-flex mb-8" *ngIf="!showCreateProjectBtn">
          <div class="ai-sourcing-diff-card">
            <i class="fa-solid fa-bullseye-arrow"></i>
            <p>Contextual Matching</p>
            <span>Understands skills, experience, and role relevance.</span>
          </div>
           <div class="ai-sourcing-diff-card">
            <i class="fa-solid fa-star"></i>
            <p>Prioritized Evaluation</p>
            <span>Rank what matters; Autopilot<sup><span>AI</span></sup> scores accordingly.</span>
          </div>
           <div class="ai-sourcing-diff-card">
            <i class="fa-solid fa-globe-pointer"></i>
            <p>Global Reach </p>
            <span>Search 630M+ profiles worldwide.</span>
          </div>
           <div class="ai-sourcing-diff-card">
            <i class="fa-solid fa-user-check"></i>
            <p>Noise-Free Results</p>
            <span>No Boolean. Just relevant candidates in minutes.</span>
          </div>
      </div>
      <div class="text-center" *ngIf="showCreateProjectBtn">

        <span class="text-speed">Speed Meets Accuracy</span>
        <p class="text-content">Whether hiring engineers, data scientists, or sales teams-Webbtree Autopilot<sup><span>AI</span></sup> delivers precision at scale. Recruiters save hours, hiring managers get better candidates, everyone wins.</p>
      </div>
      <p class="f-18 text-center mb-3 mt-3">Start Sourcing in 4 Easy Steps</p>
      <div class="d-flex mb-8">
        <div class="easy-step-card" (mouseenter)="hoveredStep = 1" (mouseleave)="hoveredStep = 0">
          <div>
            <i [ngClass]="hoveredStep === 1 ? 'fa-solid fa-file-import' : 'fa-light fa-file-import'"></i>
            <p class="steps">STEP 1</p>
            <p class="step-text">Upload Your JD</p>
          </div>
          <div (click)="learnMoreDetails()">
            <span class="learnmore">Learn More <i class="fa-regular fa-arrow-right"></i></span>
          </div>
        </div>

        <div class="easy-step-card" (mouseenter)="hoveredStep = 2" (mouseleave)="hoveredStep = 0">
          <div>
            <i [ngClass]="hoveredStep === 2 ? 'fa-solid fa-calendar-lines-pen' : 'fa-light fa-calendar-lines-pen'"></i>
            <p class="steps">STEP 2</p>
            <p class="step-text">Set Key Evaluation Criteria</p>
          </div>
          <div (click)="learnMoreDetails()">
            <span class="learnmore">Learn More <i class="fa-regular fa-arrow-right"></i></span>
          </div>
        </div>

        <div class="easy-step-card" (mouseenter)="hoveredStep = 3" (mouseleave)="hoveredStep = 0">
          <div>
            <i [ngClass]="hoveredStep === 3 ? 'fa-solid fa-stars' : 'fa-light fa-stars'"></i>
            <p class="steps">STEP 3</p>
            <p class="step-text">Webbtree Autopilot<sup><span>AI</span></sup> Matches</p>
          </div>
          <div (click)="learnMoreDetails()">
            <span class="learnmore">Learn More <i class="fa-regular fa-arrow-right"></i></span>
          </div>
        </div>

        <div class="easy-step-card" (mouseenter)="hoveredStep = 4" (mouseleave)="hoveredStep = 0">
          <div>
            <i [ngClass]="hoveredStep === 4 ? 'fa-solid fa-id-card' : 'fa-light fa-id-card'"></i>
            <p class="steps">STEP 4</p>
            <p class="step-text">Shortlist & Reveal Contact Info</p>
          </div>
          <div (click)="learnMoreDetails()">
            <span class="learnmore">Learn More <i class="fa-regular fa-arrow-right"></i></span>
          </div>
        </div>
      </div>
      <div class="testimonial-card  mb-8" *ngIf="!showCreateProjectBtn">
          <div class="feedback-box">
            <span class="quote-size">“</span>
            <p class="feedback-text">It’s like having a sourcing assistant who knows exactly what we’re looking for-without needing to explain it 5 times</p>

            <p class="author"> <span class="userpic"><i class="fa-solid fa-circle-user"></i></span> <span>Global Talent Acquisition Lead</span> </p>
          </div>
      </div>
      <button data-testid="auto-app-ai-sourcing-landingpage-button-3" class="btn-joinwaitlist-yellow mx-auto d-block mb-8" *ngIf="showWaitlistBtn" (click)="joinWaitlist()"> Join Waitlist</button>

      <button data-testid="auto-app-ai-sourcing-landingpage-button-4" class="btn-ai-sourcing-white mx-auto d-block" *ngIf="showRequestedBtn">
        <i class="fa-regular fa-clock mr-1"></i>Requested
      </button>

  </div>
</div>
<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>

<ngb-alert class="ngb-alert" style="background-color: yellow !important;" *ngIf="infoMessage" type="info"
  (close)="infoMessage = ''">
  <span class="infoCheck"><i class="fal fa-info-circle"></i></span>
  <span class="infomsg ml-1">{{ infoMessage }}</span>
</ngb-alert>
